<template>
  <app-layout>
    <LoadingScreen :isLoading="loading"></LoadingScreen>
    <br />
    <div class="flex flex-wrap mb-4 mt-10" v-if="!current.id">
      <div
        class="w-full sm:w-full md:w-1/2 lg:w-1/3 px-2 mb-4"
        v-for="course in courses"
        :key="course.id"
      >
        <content-card
          class="cursor-pointer transition-shadow duration-300"
          :class="{ 'shadow-lg': hoveredCourse === course.id }"
        >
          <div class="flex flex-row justify-between">
            <h2 class="text-lg font-semibold mb-2 text-purple-600">
              {{ course.title }}
            </h2>
            <span class="bg-blue-200 rounded-full p-1 flex items-center">
              <i class="el-icon-video-camera"></i> {{ course.videos.length }}
            </span>
          </div>
          <div class="text-sm text-gray-600" style="height: 50px">
            <p>{{ course.description }}</p>
          </div>
          <div class="mt-4 bg-purple-500 p-2 rounded text-white">
            <strong>{{ course.learnDescription }}</strong>
          </div>
          <div class="mt-4">
            <div class="flex justify-between mb-1">
              <span class="text-xs font-semibold">Progreso</span>
              <span class="text-xs text-purple-700 font-semibold"
                >{{ course.progress }}%</span
              >
            </div>
            <div class="w-full bg-purple-100 rounded-full h-3 mb-2">
              <div
                class="bg-purple-600 h-3 rounded-full transition-all duration-300"
                :style="{ width: course.progress + '%' }"
              ></div>
            </div>
          </div>
          <hr class="my-4 border-t-2 border-purple-200" />
          <div
            class="flex flex-row justify-center items-center text-center text-purple-600"
          >
            <a @click="changeCurrent(course)">
              <i class="el-icon-video-play"></i> Continuar aprendiendo
            </a>
          </div>
        </content-card>
      </div>
    </div>
    <div class="flex flex-col p-4 mt-10" v-if="current.id">
      <div class="w-full flex flex-col lg:flex-row">
        <button
          v-if="current.id"
          class="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition-colors duration-200"
          @click="changeCurrent({})"
        >
          <i class="el-icon-back mr-2"></i> Volver a la lista de cursos
        </button>
      </div>
      <div
        class="w-full flex flex-col lg:flex-row mt-4"
        v-if="current.progress >= 100"
      >
        <div class="w-full w-full px-2">
          <content-card class="bg-green-100 border-l-4 border-green-500">
            <div class="flex flex-col">
              <h2 class="text-lg font-semibold mb-2 text-green-600">
                ¡Felicidades!
              </h2>
              <p class="text-gray-700">
                Has completado este curso. Puedes continuar con el siguiente
                curso o revisar los videos que ya has visto.
              </p>
            </div>
          </content-card>
        </div>
      </div>
    </div>
    <div class="flex flex-col lg:flex-row p-4" v-if="current.id">
      <div class="w-full flex flex-col lg:flex-row">
        <div class="w-full sm:w-full lg:w-1/3 px-2 mb-4">
          <content-card class="cursor-pointer transition-shadow duration-300">
            <div class="flex flex-row justify-between">
              <h2 class="text-lg font-semibold mb-2 text-purple-600">
                {{ current.title }}
              </h2>
              <span class="bg-blue-200 rounded-full p-1 flex items-center">
                <i class="el-icon-video-camera"></i> {{ current.videos.length }}
              </span>
            </div>
            <div class="text-sm text-gray-600" style="height: 50px">
              <p>{{ current.description }}</p>
            </div>
            <div class="mt-4 bg-purple-500 p-2 rounded text-white">
              <strong>{{ current.learnDescription }}</strong>
            </div>
            <div class="mt-4">
              <div class="flex justify-between mb-1">
                <span class="text-xs font-semibold">Progreso</span>
                <span class="text-xs text-purple-700 font-semibold"
                  >{{ current.progress }}%</span
                >
              </div>
              <div class="w-full bg-purple-100 rounded-full h-3 mb-2">
                <div
                  class="bg-purple-600 h-3 rounded-full transition-all duration-300"
                  :style="{ width: current.progress + '%' }"
                ></div>
              </div>
            </div>
            <div class="flex flex-col">
              <label>
                <i class="el-icon-video-camera"></i>
                <strong> {{ current.videos.length }}</strong> videos</label
              >
              <label>
                <i class="el-icon-check"></i>
                <strong>
                  {{
                    current.videos.filter((x) => x.isViewed === true).length
                  }}</strong
                >
                de
                <strong>{{ current.videos.length }}</strong> completados</label
              >
            </div>
          </content-card>
          <content-card class="mt-4">
            <div class="flex flex-col">
              <h2 class="text-lg font-semibold mb-2 text-purple-600">
                Lista de videos
              </h2>
              <label>Selecciona un video para verlo</label>
              <ul class="list-none p-0 mt-5">
                <li
                  v-for="(video, index) in current.videos"
                  :key="video.id"
                  class="cursor-pointer hover:bg-purple-100 p-2 rounded transition-colors duration-200"
                  :class="{ 'bg-purple-200': video.isViewed }"
                  @click="changeCurrentVideo(video)"
                >
                  <i
                    class="el-icon-video-camera mr-2"
                    :class="{ 'text-green-600': video.isViewed }"
                  ></i>
                  {{ video.title }}
                  <br />
                  <span class="text-xs text-gray-600 pl-6"
                    >Video {{ index + 1 }} de {{ current.videos.length }}</span
                  >
                </li>
              </ul>
            </div>
          </content-card>
        </div>
        <div class="w-full sm:w-full lg:w-2/3 px-2 mb-4">
          <content-card>
            <div class="flex">
              <div class="w-full">
                <h2
                  class="text-lg font-semibold mb-2 text-purple-600"
                  v-if="!video.id"
                >
                  {{ video.title || "Selecciona un video para ver" }}
                </h2>
                <iframe
                  v-if="video.youtube_video_id"
                  width="100%"
                  :height="width * 0.5625"
                  :src="
                    'https://www.youtube.com/embed/' + video.youtube_video_id
                  "
                  frameborder="0"
                  allowfullscreen
                ></iframe>
                <p v-else class="text-gray-600 mt-4">
                  Por favor, selecciona un video de la lista a la izquierda.
                </p>
                <div class="mt-4" v-if="video.id">
                  <h2 class="text-lg font-semibold mb-2 text-purple-600">
                    {{ video.title || "Selecciona un video para ver" }}
                  </h2>
                  <div class="flex flex-row justify-between items-center">
                    <span
                      >Video
                      <strong>{{
                        current.videos.findIndex((x) => x.id === video.id) + 1
                      }}</strong>
                      de <strong>{{ current.videos.length }}</strong></span
                    >
                    <button
                      v-if="video.id"
                      class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors duration-200"
                      @click="viewVideo(video)"
                    >
                      <i class="el-icon-check"></i> Marcar como visto
                    </button>
                  </div>
                  <p class="italic text-gray-700 mt-2">
                    Recuerda marcar este video como visto cuando hayas terminado
                    de verlo para llevar un seguimiento de tu progreso en el
                    curso.
                  </p>
                </div>
              </div>
            </div>
          </content-card>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import _ from "lodash";
import responsiveSize from "@/mixins/responsiveSize";
import TutorialService from "@/services/TutorialService";

export default {
  name: "CoursesIndex",
  mixins: [responsiveSize],
  components: {
    AppLayout: () => import("@/components/layouts/AppLayout.vue"),
    ContentCard: () => import("@/components/molecules/ContentCard.vue"),
    LoadingScreen: () => import("@/components/layouts/LoadingScreen"),
  },
  data() {
    return {
      loading: true,
      width: 640,
      courses: [],
      current: {},
      video: {},
    };
  },
  created() {
    window.addEventListener("resize", _.debounce(this.resize, 200));
    this.resize();
  },
  destroyed() {
    window.removeEventListener("resize", _.debounce(this.resize, 200));
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      let courses = await TutorialService.get();
      courses = courses.courses || [];
      this.courses = courses
        .sort((a, b) => a.order - b.order)
        .map((course) => ({
          id: course.id,
          title: course.title,
          description: course.description,
          learnDescription: course.learnDescription,
          videos: course.videos.map((video) => ({
            id: video.id,
            title: video.title,
            youtube_video_id: video.url.replace("https://youtu.be/", ""),
            isViewed: video.isViewed,
            order: video.order,
          })),
          progress: course.progress,
        }));
      this.loading = false;
    },
    resize() {
      const { outerWidth } = window;
      this.width = outerWidth / 1.75;
    },
    changeCurrent(course) {
      this.current = course;
      if (!course.id) {
        this.changeCurrentVideo({});
      }
    },
    changeCurrentVideo(video) {
      this.video = video;
    },
    async viewVideo(video) {
      this.loading = true;
      await TutorialService.updateView(video.id);
      if (video.id) {
        const index = this.current.videos.findIndex((x) => x.id === video.id);
        if (index !== -1) {
          this.current.videos[index].isViewed = true;
          this.current.progress =
            Math.round(
              (this.current.videos.filter((x) => x.isViewed).length /
                this.current.videos.length) *
                100 *
                100
            ) / 100;
        }
      }
      this.loading = false;
    },
  },
};
</script>
